import { FindingSummary } from "types/api/findingSummary";

import { ACTableProps } from "ac-components/ACTable/ACTable";
import ACResizableColumnCell from "ac-components/ac-resizable-column-cell/ACResizableColumnCell";

export const CommonTableProps: ACTableProps<FindingSummary> = {
  rowKey: "id",
  sticky: true,
  autoEnableScroll: true,
  computeTableWidth: true,
  components: {
    header: {
      cell: ACResizableColumnCell,
    },
  },
};
